import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'air-freshener': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSprayCanSparkles" */
        '@fortawesome/free-solid-svg-icons/faSprayCanSparkles'
    ),
    'angle-double-left': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAnglesLeft" */
        '@fortawesome/free-solid-svg-icons/faAnglesLeft'
    ),
    'arrow-circle-left': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCircleArrowLeft" */
        '@fortawesome/free-solid-svg-icons/faCircleArrowLeft'
    ),
    'arrow-up-right-from-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faExternalLink" */
        '@fortawesome/free-solid-svg-icons/faExternalLink'
    ),
    'arrows-left-right-to-line': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faArrowsLeftRightToLine" */
        '@fortawesome/free-solid-svg-icons/faArrowsLeftRightToLine'
    ),
    'arrows-to-dot': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faArrowsToDot" */
        '@fortawesome/free-solid-svg-icons/faArrowsToDot'
    ),
    'at': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAt" */
        '@fortawesome/free-solid-svg-icons/faAt'
    ),
    'austral-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAustralSign" */
        '@fortawesome/free-solid-svg-icons/faAustralSign'
    ),
    'backward-fast': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFastBackward" */
        '@fortawesome/free-solid-svg-icons/faFastBackward'
    ),
    'bacon': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBacon" */
        '@fortawesome/free-solid-svg-icons/faBacon'
    ),
    'bandage': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBandage" */
        '@fortawesome/free-solid-svg-icons/faBandage'
    ),
    'battery-0': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBatteryEmpty" */
        '@fortawesome/free-solid-svg-icons/faBatteryEmpty'
    ),
    'battery-5': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBatteryFull" */
        '@fortawesome/free-solid-svg-icons/faBatteryFull'
    ),
    'blender': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBlender" */
        '@fortawesome/free-solid-svg-icons/faBlender'
    ),
    'book-open-reader': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBookReader" */
        '@fortawesome/free-solid-svg-icons/faBookReader'
    ),
    'book-reader': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBookReader" */
        '@fortawesome/free-solid-svg-icons/faBookReader'
    ),
    'bowl-food': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBowlFood" */
        '@fortawesome/free-solid-svg-icons/faBowlFood'
    ),
    'bullhorn': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBullhorn" */
        '@fortawesome/free-solid-svg-icons/faBullhorn'
    ),
    'bus-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBusSimple" */
        '@fortawesome/free-solid-svg-icons/faBusSimple'
    ),
    'calendar-days': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCalendarDays" */
        '@fortawesome/free-solid-svg-icons/faCalendarDays'
    ),
    'caret-square-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareCaretDown" */
        '@fortawesome/free-solid-svg-icons/faSquareCaretDown'
    ),
    'carriage-baby': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCarriageBaby" */
        '@fortawesome/free-solid-svg-icons/faCarriageBaby'
    ),
    'champagne-glasses': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGlassCheers" */
        '@fortawesome/free-solid-svg-icons/faGlassCheers'
    ),
    'chart-gantt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faChartGantt" */
        '@fortawesome/free-solid-svg-icons/faChartGantt'
    ),
    'circle-check': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCircleCheck" */
        '@fortawesome/free-solid-svg-icons/faCircleCheck'
    ),
    'circle-h': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHospitalSymbol" */
        '@fortawesome/free-solid-svg-icons/faHospitalSymbol'
    ),
    'circle-play': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPlayCircle" */
        '@fortawesome/free-solid-svg-icons/faPlayCircle'
    ),
    'circle-user': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUserCircle" */
        '@fortawesome/free-solid-svg-icons/faUserCircle'
    ),
    'close': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faXmark" */
        '@fortawesome/free-solid-svg-icons/faXmark'
    ),
    'code-pull-request': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCodePullRequest" */
        '@fortawesome/free-solid-svg-icons/faCodePullRequest'
    ),
    'dharmachakra': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDharmachakra" */
        '@fortawesome/free-solid-svg-icons/faDharmachakra'
    ),
    'diagram-predecessor': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDiagramPredecessor" */
        '@fortawesome/free-solid-svg-icons/faDiagramPredecessor'
    ),
    'diamond': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDiamond" */
        '@fortawesome/free-solid-svg-icons/faDiamond'
    ),
    'dice-four': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDiceFour" */
        '@fortawesome/free-solid-svg-icons/faDiceFour'
    ),
    'drafting-compass': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDraftingCompass" */
        '@fortawesome/free-solid-svg-icons/faDraftingCompass'
    ),
    'drum-steelpan': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDrumSteelpan" */
        '@fortawesome/free-solid-svg-icons/faDrumSteelpan'
    ),
    'face-grin-beam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGrinBeam" */
        '@fortawesome/free-solid-svg-icons/faGrinBeam'
    ),
    'face-grin-beam-sweat': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGrinBeamSweat" */
        '@fortawesome/free-solid-svg-icons/faGrinBeamSweat'
    ),
    'face-grin-tears': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGrinTears" */
        '@fortawesome/free-solid-svg-icons/faGrinTears'
    ),
    'file-invoice': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFileInvoice" */
        '@fortawesome/free-solid-svg-icons/faFileInvoice'
    ),
    'file-powerpoint': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFilePowerpoint" */
        '@fortawesome/free-solid-svg-icons/faFilePowerpoint'
    ),
    'file-prescription': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFilePrescription" */
        '@fortawesome/free-solid-svg-icons/faFilePrescription'
    ),
    'file-waveform': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFileWaveform" */
        '@fortawesome/free-solid-svg-icons/faFileWaveform'
    ),
    'fire-extinguisher': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFireExtinguisher" */
        '@fortawesome/free-solid-svg-icons/faFireExtinguisher'
    ),
    'futbol': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSoccerBall" */
        '@fortawesome/free-solid-svg-icons/faSoccerBall'
    ),
    'ghost': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGhost" */
        '@fortawesome/free-solid-svg-icons/faGhost'
    ),
    'globe': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGlobe" */
        '@fortawesome/free-solid-svg-icons/faGlobe'
    ),
    'grin-tears': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGrinTears" */
        '@fortawesome/free-solid-svg-icons/faGrinTears'
    ),
    'grin-tongue': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGrinTongue" */
        '@fortawesome/free-solid-svg-icons/faGrinTongue'
    ),
    'h-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareH" */
        '@fortawesome/free-solid-svg-icons/faSquareH'
    ),
    'hand-holding-droplet': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandHoldingWater" */
        '@fortawesome/free-solid-svg-icons/faHandHoldingWater'
    ),
    'hands-wash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandsWash" */
        '@fortawesome/free-solid-svg-icons/faHandsWash'
    ),
    'hill-avalanche': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHillAvalanche" */
        '@fortawesome/free-solid-svg-icons/faHillAvalanche'
    ),
    'hospital-user': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHospitalUser" */
        '@fortawesome/free-solid-svg-icons/faHospitalUser'
    ),
    'house-crack': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHouseCrack" */
        '@fortawesome/free-solid-svg-icons/faHouseCrack'
    ),
    'image': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faImage" */
        '@fortawesome/free-solid-svg-icons/faImage'
    ),
    'jet-fighter': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faJetFighter" */
        '@fortawesome/free-solid-svg-icons/faJetFighter'
    ),
    'kaaba': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faKaaba" */
        '@fortawesome/free-solid-svg-icons/faKaaba'
    ),
    'kiwi-bird': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faKiwiBird" */
        '@fortawesome/free-solid-svg-icons/faKiwiBird'
    ),
    'landmark-dome': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLandmarkDome" */
        '@fortawesome/free-solid-svg-icons/faLandmarkDome'
    ),
    'level-down-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTurnDown" */
        '@fortawesome/free-solid-svg-icons/faTurnDown'
    ),
    'location-dot': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMapMarkerAlt" */
        '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
    ),
    'magic-wand-sparkles': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWandMagicSparkles" */
        '@fortawesome/free-solid-svg-icons/faWandMagicSparkles'
    ),
    'mattress-pillow': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMattressPillow" */
        '@fortawesome/free-solid-svg-icons/faMattressPillow'
    ),
    'message': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMessage" */
        '@fortawesome/free-solid-svg-icons/faMessage'
    ),
    'microphone': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMicrophone" */
        '@fortawesome/free-solid-svg-icons/faMicrophone'
    ),
    'n': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faN" */
        '@fortawesome/free-solid-svg-icons/faN'
    ),
    'navicon': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faNavicon" */
        '@fortawesome/free-solid-svg-icons/faNavicon'
    ),
    'not-equal': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faNotEqual" */
        '@fortawesome/free-solid-svg-icons/faNotEqual'
    ),
    'object-ungroup': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faObjectUngroup" */
        '@fortawesome/free-solid-svg-icons/faObjectUngroup'
    ),
    'paintbrush': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPaintbrush" */
        '@fortawesome/free-solid-svg-icons/faPaintbrush'
    ),
    'pause-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPauseCircle" */
        '@fortawesome/free-solid-svg-icons/faPauseCircle'
    ),
    'pen-to-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPenToSquare" */
        '@fortawesome/free-solid-svg-icons/faPenToSquare'
    ),
    'person-circle-question': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPersonCircleQuestion" */
        '@fortawesome/free-solid-svg-icons/faPersonCircleQuestion'
    ),
    'person-walking-arrow-right': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPersonWalkingArrowRight" */
        '@fortawesome/free-solid-svg-icons/faPersonWalkingArrowRight'
    ),
    'plug-circle-bolt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPlugCircleBolt" */
        '@fortawesome/free-solid-svg-icons/faPlugCircleBolt'
    ),
    'q': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faQ" */
        '@fortawesome/free-solid-svg-icons/faQ'
    ),
    'random': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faShuffle" */
        '@fortawesome/free-solid-svg-icons/faShuffle'
    ),
    'road-bridge': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRoadBridge" */
        '@fortawesome/free-solid-svg-icons/faRoadBridge'
    ),
    'road-circle-xmark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRoadCircleXmark" */
        '@fortawesome/free-solid-svg-icons/faRoadCircleXmark'
    ),
    'rug': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRug" */
        '@fortawesome/free-solid-svg-icons/faRug'
    ),
    'running': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRunning" */
        '@fortawesome/free-solid-svg-icons/faRunning'
    ),
    'rupee-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRupeeSign" */
        '@fortawesome/free-solid-svg-icons/faRupeeSign'
    ),
    'sack-dollar': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSackDollar" */
        '@fortawesome/free-solid-svg-icons/faSackDollar'
    ),
    'sad-cry': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSadCry" */
        '@fortawesome/free-solid-svg-icons/faSadCry'
    ),
    'scale-balanced': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faScaleBalanced" */
        '@fortawesome/free-solid-svg-icons/faScaleBalanced'
    ),
    'school': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSchool" */
        '@fortawesome/free-solid-svg-icons/faSchool'
    ),
    'scissors': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faScissors" */
        '@fortawesome/free-solid-svg-icons/faScissors'
    ),
    'search-dollar': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSearchDollar" */
        '@fortawesome/free-solid-svg-icons/faSearchDollar'
    ),
    'section': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSection" */
        '@fortawesome/free-solid-svg-icons/faSection'
    ),
    'shower': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faShower" */
        '@fortawesome/free-solid-svg-icons/faShower'
    ),
    'sign-hanging': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSignHanging" */
        '@fortawesome/free-solid-svg-icons/faSignHanging'
    ),
    'skiing': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSkiing" */
        '@fortawesome/free-solid-svg-icons/faSkiing'
    ),
    'smog': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSmog" */
        '@fortawesome/free-solid-svg-icons/faSmog'
    ),
    'sort-alpha-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortAlphaUp" */
        '@fortawesome/free-solid-svg-icons/faSortAlphaUp'
    ),
    'sort-amount-desc': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortAmountDownAlt" */
        '@fortawesome/free-solid-svg-icons/faSortAmountDownAlt'
    ),
    'sort-numeric-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortNumericDown" */
        '@fortawesome/free-solid-svg-icons/faSortNumericDown'
    ),
    'sort-numeric-down-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortNumericDownAlt" */
        '@fortawesome/free-solid-svg-icons/faSortNumericDownAlt'
    ),
    'sort-numeric-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortNumericUp" */
        '@fortawesome/free-solid-svg-icons/faSortNumericUp'
    ),
    'sort-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSortUp" */
        '@fortawesome/free-solid-svg-icons/faSortUp'
    ),
    'spray-can': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSprayCan" */
        '@fortawesome/free-solid-svg-icons/faSprayCan'
    ),
    'square-arrow-up-right': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareArrowUpRight" */
        '@fortawesome/free-solid-svg-icons/faSquareArrowUpRight'
    ),
    'square-full': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareFull" */
        '@fortawesome/free-solid-svg-icons/faSquareFull'
    ),
    'square-nfi': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquareNfi" */
        '@fortawesome/free-solid-svg-icons/faSquareNfi'
    ),
    'square-person-confined': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquarePersonConfined" */
        '@fortawesome/free-solid-svg-icons/faSquarePersonConfined'
    ),
    'square-phone-flip': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquarePhoneFlip" */
        '@fortawesome/free-solid-svg-icons/faSquarePhoneFlip'
    ),
    'star-half': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faStarHalf" */
        '@fortawesome/free-solid-svg-icons/faStarHalf'
    ),
    'street-view': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faStreetView" */
        '@fortawesome/free-solid-svg-icons/faStreetView'
    ),
    't-shirt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTShirt" */
        '@fortawesome/free-solid-svg-icons/faTShirt'
    ),
    'table-list': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faThList" */
        '@fortawesome/free-solid-svg-icons/faThList'
    ),
    'tachometer-alt-fast': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTachometerAltFast" */
        '@fortawesome/free-solid-svg-icons/faTachometerAltFast'
    ),
    'television': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTvAlt" */
        '@fortawesome/free-solid-svg-icons/faTvAlt'
    ),
    'temperature-0': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faThermometerEmpty" */
        '@fortawesome/free-solid-svg-icons/faThermometerEmpty'
    ),
    'temperature-4': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faThermometerFull" */
        '@fortawesome/free-solid-svg-icons/faThermometerFull'
    ),
    'tent': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTent" */
        '@fortawesome/free-solid-svg-icons/faTent'
    ),
    'u': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faU" */
        '@fortawesome/free-solid-svg-icons/faU'
    ),
    'up-right-from-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUpRightFromSquare" */
        '@fortawesome/free-solid-svg-icons/faUpRightFromSquare'
    ),
    'upload': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUpload" */
        '@fortawesome/free-solid-svg-icons/faUpload'
    ),
    'user-friends': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUserGroup" */
        '@fortawesome/free-solid-svg-icons/faUserGroup'
    ),
    'user-group': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUserGroup" */
        '@fortawesome/free-solid-svg-icons/faUserGroup'
    ),
    'user-xmark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUserXmark" */
        '@fortawesome/free-solid-svg-icons/faUserXmark'
    ),
    'users-slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUsersSlash" */
        '@fortawesome/free-solid-svg-icons/faUsersSlash'
    ),
    'vest-patches': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVestPatches" */
        '@fortawesome/free-solid-svg-icons/faVestPatches'
    ),
    'warning': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWarning" */
        '@fortawesome/free-solid-svg-icons/faWarning'
    ),
    'weight': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWeightScale" */
        '@fortawesome/free-solid-svg-icons/faWeightScale'
    ),
    'wind': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWind" */
        '@fortawesome/free-solid-svg-icons/faWind'
    ),
    'won': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWonSign" */
        '@fortawesome/free-solid-svg-icons/faWonSign'
    ),
    'zap': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faZap" */
        '@fortawesome/free-solid-svg-icons/faZap'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>